import * as React from 'react'
import TextContainer from '../layout/TextContainer';
import TerminalNodeStatus from './TerminalNodeStatus';


type Props = {

  className?: string
}

const TerminalStatusSection: React.FC<Props> = ({ className = '' }) => {

  return (
    <div className={' ' + className}>
      <TextContainer>

        <h2 id="categories" className="text-xl font-bold mb-2 text-gray-800">Node categories</h2>
        <p>Terminal categorizes nodes in three different categories depending on how well they match 
          the <a className="underline" href="#node-heuristics">node heuristics</a>.</p>
        <table className="my-4">
          <tbody>
          <tr>
              <td className="pl-4 pr-8 ">
              <TerminalNodeStatus status="scored" className="inline-block" />
              </td>
              <td className="py-2">
              The node matches all heuristics*.
              </td>
            </tr>
            <tr>
              <td className="pl-4 pr-8 ">
              <TerminalNodeStatus status="stable" className="inline-block" />
              </td>
              <td className="py-2">
              The node match the <span className="italic">stable</span> heuristics.
              </td>
            </tr>
            <tr>
              <td className="pl-4 pr-8 ">
              <TerminalNodeStatus status="unstable" className="inline-block" />
              </td>
              <td className="py-2">
              The node does not match the <span className="italic">stable</span> heuristics.
              </td>
            </tr>
          </tbody>
        </table>

      </TextContainer>
    </div>
  );
}

export default TerminalStatusSection;

